import { TODO } from '@b2b/types/core/utils';
import uiRouter from '@uirouter/angularjs';
import angular from 'angular';
import { PricingDiscountsModule } from './controllers/PricingDiscountsController';

export const PricingDiscountsView = angular
  .module('acme.view.application.pricing.discounts', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.helpers',
    'acme.view.application.pricing.discounts.sidebar.controllers',
    PricingDiscountsModule,
  ])

  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    var pricingDiscounts = {
      name: 'application.pricing.discounts',
      url: '/discounts',
      views: {
        'subview-main@application': {
          controller: 'PricingDiscountsController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/pricing/discounts/discounts.tpl.html',
        },
      },
      data: {
        pageTitle: 'Discounts',
        permissions: ['DISCOUNTS_VIEW'],
      },
      resolve: {
        DiscountsData: [
          'ApiService',
          'HelpersService',
          function (ApiService: TODO, HelpersService) {
            return ApiService.discounts.list('v2', HelpersService.getPaginator());
          },
        ],
        PersonTypesData: [
          'ApiService',
          'HelpersService',
          function (ApiService: TODO, HelpersService) {
            return ApiService.price.types.list(
              Object.assign({}, HelpersService.getPaginator({ sortField: 'displayOrder', sortDirection: 'asc' }), {
                types: 'all',
                inactive: true,
              })
            );
          },
        ],
      },
    };

    $stateProvider.state(pricingDiscounts);
  }).name;
